<template>
  <div class="content">
    <div class="container form--restore-success">
      <header-logo :logo-url="globalLogoUrl" />
      <h1 v-word:layout.passwordRecovery.success.header></h1>
      <h2 v-word:layout.passwordRecovery.success />
      <section class="form__section">
        <div class="form__section__links form__section__links--back">
          <a class="button"
             :href="!editMode && $router.resolve({ name: 'login' }).href"
             v-word:layout.passwordRecoverySuccess.link.backToLogin />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';

export default {
  mixins: [mixins.wordedPage, mixins.pageWithLogo],
};
</script>



// WEBPACK FOOTER //
// src/pages/RestorePasswordMailSent.vue